(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card-1"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-card-gallery')) {
    class ProductCardGallery extends HTMLElement {
      constructor() {
        super();
        this.track = null;
        this.dragState = null;
        this.currentIndex = 0;
        this._scrollRaf = null;
      }

      connectedCallback() {
        this.track = this.querySelector('.m-product-card__gallery-track');
        this.prevBtn = this.querySelector('[data-gallery-prev]');
        this.nextBtn = this.querySelector('[data-gallery-next]');
        this.dots = Array.from(this.querySelectorAll('[data-gallery-dot]'));

        if (!this.track) return;

        this.slides = Array.from(this.track.querySelectorAll('.m-product-card__gallery-slide'));

        this._setInitialSlide();

        this.prevBtn && this.prevBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this._scrollByOne(-1);
        });
        this.nextBtn && this.nextBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this._scrollByOne(1);
        });

        this.dots.forEach((dot, index) => {
          dot.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this._activateSlide(this.slides[index]);
          });
        });

        if (this.slides.length > 1) {
          // Drives click-and-drag sliding on mouse/desktop. Touch pointers
          // are ignored inside the handler and fall through to native
          // scroll-snap swiping instead.
          this.track.addEventListener('pointerdown', this._onPointerDown.bind(this));
        }

        this.track.addEventListener('click', this._onClickCapture.bind(this), true);
        this.track.addEventListener('scroll', this._onScroll.bind(this), { passive: true });

        this.addEventListener('variant:change', (event) => {
          const variant = event.detail && event.detail.variant;
          const mediaId = variant && variant.featured_media && variant.featured_media.id;
          if (mediaId) this._goToMediaId(mediaId);
        });
      }

      _setInitialSlide() {
        const initialId = this.dataset.initialMediaId;
        const slide = initialId
          ? this.track.querySelector(`[data-media-id="${initialId}"]`)
          : this.slides[0];
        if (slide) this._activateSlide(slide, false);
      }

      _activateSlide(slide, smooth) {
        if (!slide) return;
        this.track.scrollTo({
          left: slide.offsetLeft,
          behavior: smooth === false ? 'auto' : 'smooth',
        });
        this._setActiveIndex(this.slides.indexOf(slide));
      }

      _goToMediaId(mediaId, smooth) {
        const slide = this.track.querySelector(`[data-media-id="${mediaId}"]`);
        this._activateSlide(slide, smooth);
      }

      _setActiveIndex(index) {
        if (index < 0) return;
        this.currentIndex = index;
        this.slides.forEach((s, i) => s.classList.toggle('is-active', i === index));
        this.dots.forEach((d, i) => d.classList.toggle('is-active', i === index));
      }

      _scrollByOne(direction) {
        const width = this.track.clientWidth;
        this.track.scrollBy({ left: width * direction, behavior: 'smooth' });
      }

      _onScroll() {
        if (this._scrollRaf) return;
        this._scrollRaf = requestAnimationFrame(() => {
          this._scrollRaf = null;
          const width = this.track.clientWidth;
          if (!width) return;
          const index = Math.round(this.track.scrollLeft / width);
          if (index !== this.currentIndex) this._setActiveIndex(index);
        });
      }

      _onPointerDown(event) {
        if (event.pointerType !== 'mouse') return; // let touch swipe natively
        event.preventDefault();
        this.dragState = {
          startX: event.clientX,
          scrollLeft: this.track.scrollLeft,
          moved: false,
        };
        this.track.classList.add('is-dragging');
        this.track.setPointerCapture(event.pointerId);

        const onMove = (moveEvent) => {
          if (!this.dragState) return;
          const delta = moveEvent.clientX - this.dragState.startX;
          if (Math.abs(delta) > 5) this.dragState.moved = true;
          this.track.scrollLeft = this.dragState.scrollLeft - delta;
        };

        const onUp = () => {
          this.track.classList.remove('is-dragging');
          this.track.removeEventListener('pointermove', onMove);
          this.track.removeEventListener('pointerup', onUp);
          this.track.removeEventListener('pointercancel', onUp);
          if (this.dragState && this.dragState.moved) {
            this._snapToNearest();
          }

          requestAnimationFrame(() => { this.dragState = null; });
        };

        this.track.addEventListener('pointermove', onMove);
        this.track.addEventListener('pointerup', onUp);
        this.track.addEventListener('pointercancel', onUp);
      }

      _snapToNearest() {
        const width = this.track.clientWidth;
        const index = Math.round(this.track.scrollLeft / width);
        this.track.scrollTo({ left: index * width, behavior: 'smooth' });
      }

      _onClickCapture(event) {
        if (this.dragState && this.dragState.moved) {
          event.preventDefault();
          event.stopPropagation();
        }
      }
    }

    customElements.define('product-card-gallery', ProductCardGallery);
  }
  } catch(e) { console.error(e); }
})();

})();
